






import { Link } from "react-router-dom";
import { MobileMenu } from './mobilemenu'
import './mynavbar.css'

export function MyNav(props) {
    const { no_buy_button } = props
    console.log('props =',props)
    return (
        <div className="second-bar"> {/*  style={{display:'none'}} */}
            <div className="links-container">
                <Link className="nunisynth-text" to="/">NUNISYNTH</Link>
                <Link to="/create">Create</Link>
                <Link to="/experiment">Experiment</Link>
                <Link to="/newsupdates">Release Notes</Link>
            </div>

            <MobileMenu/>

            {no_buy_button 
                ? <div style={{width:'100%'}}></div> 
                : <span className="price-btn-container">
                    <span className="price-tag">$59.00</span>
                    <Link className="buy-now" to="/buynunisynth">BUY NOW</Link>
                </span>}
        </div>
    )
}